import React from 'react';

export interface ChatMessageSkeletonProps {
    isQuery?: boolean;
}

export const ChatMessageSkeleton: React.FC<ChatMessageSkeletonProps> = ({ isQuery = false }) => {
    return (
        <div className={`flex ${isQuery ? 'justify-end' : 'justify-start'}`}>
            <div className={`relative max-w-[85%] rounded-lg p-3 ${isQuery ? 'bg-accent' : 'bg-muted'}`}>
                <div className="flex gap-3">
                    {!isQuery && (
                        <div className="flex-shrink-0">
                            <div className="w-8 h-8 bg-muted-foreground/20 rounded-full animate-pulse" />
                        </div>
                    )}
                    <div className="flex-1 space-y-2">
                        <div className="h-4 w-32 bg-muted-foreground/20 rounded animate-pulse" />
                        <div className="h-4 w-24 bg-muted-foreground/20 rounded animate-pulse" />
                        <div className="h-4 w-40 bg-muted-foreground/20 rounded animate-pulse" />
                    </div>
                </div>
            </div>
        </div>
    );
};
